import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import { listSpeedManagmentService } from "../services/listSpeedManagment.service";

export const useSpeedManagmentQuery = (filters) => {
  const fetchData = useFetch();
  const [speedManagmentData, setSpeedManagmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchSpeedManagment = async () => {
      setLoading(true);
      try {
        const response = await listSpeedManagmentService(fetchData)({
          ...filters,
        });
        setSpeedManagmentData(response.data || []);
        setTotal(response.total || 0);
      } catch (error) {
        console.error("Error fetching speed management data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSpeedManagment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, refresh]);

  return {
    speedManagmentData,
    loading,
    total,
    refresh: () => setRefresh((prev) => !prev),
  };
};
